export default "__VITE_ASSET__CHuz5soS__"